import { FC } from 'react'
import { generateSrcSet } from 'project/image-proxy-web'
import SubscriptionPricing from 'components/SubscriptionPricing'
import useWindowSize from 'components/util/useWindowSize'
import { TPlanSummary } from 'common/cms-types'
import { PlanSlug } from 'common/planSlugs'
import { ButtonType } from 'types/global'

const MEDIA = {
    desktop: { src: '/images/new/robot-pointing-right.png', width: 818, height: 717 },
    mobile: { src: '/images/new/robot-holding-mail.png', width: 393, height: 507 },
}

interface NoBoundariesLimitiationsSectionProps {
    plans: TPlanSummary[]
}

const NoBoundariesLimitiationsSection: FC<NoBoundariesLimitiationsSectionProps> = ({ plans }) => {
    const { isLgOrHigher } = useWindowSize()
    const media = isLgOrHigher ? MEDIA.desktop : MEDIA.mobile
    const scanLitePlan = plans?.find((p) => p.slug === PlanSlug.SCAN_LITE)

    const imgProps = {
        ...generateSrcSet(media.src, media.width, media.height),
        loading: 'lazy' as const,
        className: 'img-fluid',
        height: media.height,
        width: media.width,
    }

    return (
        <div className="d-flex flex-lg-row flex-column align-items-center">
            {isLgOrHigher && (
                <img {...imgProps} alt="HaiRo™ pointing right" />
            )}
            <div>
                <h3 className="fs-fluid-36-48 lh-132 color-pink2 mb-lg-5">
                    No boundaries.<br />
                    No Limitations.<br />
                    Same-day setup.<br />
                    No daily commute.<br />
                    Permanent address.<br />
                    Reclaim your time.<br />
                    Safe and secure.
                </h3>
                {!isLgOrHigher && (
                    <img {...imgProps} alt="HaiRo™ holding mail" />
                )}
                {scanLitePlan && (
                    <SubscriptionPricing
                        planSummary={scanLitePlan}
                        className="text-center text-lg-start"
                        buttonType={ButtonType.VIRTUAL_OFFICE_LONDON_KEY_BENEFITS_CTA}
                        buttonAlign="start"
                    />
                )}
            </div>
        </div>
    )
}

export default NoBoundariesLimitiationsSection
